import * as urls from "./url";
import client, { getHeader } from "../client";
import { interceptor, substituteEncrypted } from "../../util/util";

export const getSupportCaseType = (payload) => interceptor(() => client.post(urls.SUPPORT_TYPE_COUNT, substituteEncrypted(payload), getHeader()));
